import { Directive } from "@angular/core";
import { BetPanelComponent } from "./bet-panel.component";
import { EBetSplit } from "../core/round/interfaces";

@Directive({
    selector: "[bet-panel-wallet-animation]"
})
export class BetPanelWalletAnimationDirective {
    constructor(private host: BetPanelComponent) {
    }

    startWalletAnimation(split: EBetSplit): void {
        this.host.startWalletAnimation(split);
    }
}
